export const builds_api_url = process.env.REACT_APP_FIREBASE_CONFIG === 'production'
  ? 'https://builds-api-u7wfvp56wa-ew.a.run.app'
  : process.env.REACT_APP_FIREBASE_CONFIG === 'localhost'
    ? 'http://localhost:2024'
    : 'https://builds-api-pj2r6ugwdq-ew.a.run.app';
